import { reactive } from '@vue/composition-api';

const snackbar = reactive({
  show: false,
  text: 'test',
  type: '',
  color: 'error'
});

export default function useSnackbarNotifications() {
  const updateSnackbar = updateObject => {
    Object.keys(updateObject).forEach(key => {
      snackbar[key] = updateObject[key];
    });
    console.log('snackbar', snackbar);
  };
  return {
    snackbar,
    updateSnackbar
  };
}
